import { useDeviceId } from '~/composables/deviceId';

const HEADER_DEVICE_ID = 'Device-Id';

export default defineNuxtPlugin({
	order: 0,
	parallel: false,
	name: 'api',
	hooks: {
		'app:created': () => {
			const router = useRouter();

			const query = router.currentRoute.value.query;

			if (query.applicationCode !== undefined) {
				useApplicationCode().setApplicationCode(query.applicationCode as string);
			}
		},
	},
	setup: () => {
		const { deviceId } = useDeviceId();
		const api = $fetch.create({
			// baseURL: apiUrl,
			headers: {
				[HEADER_DEVICE_ID]: deviceId.value,
			},
		});
		return {
			provide: {
				api,
			},
		};
	},
});
